import AddQuestionModal from "pages/ManagementPage/questionSection/AddQuestionModal/AddQuestionModal";

export default AddQuestionModal;
